import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ActionSheetController, ToastController, LoadingController } from 'ionic-angular';
import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';
import { ConsumerHandlerProvider } from '../../providers/consumer-handler';
import { ProductPaymentCheckoutHandler } from '../../providers/product-payment-checkout-handler';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { Globals } from '../../providers/globals';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
/**
 * Generated class for the BusinessProductPaymentManagerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-product-payment-checkout',
  templateUrl: 'business-product-payment-checkout.html',
})
export class BusinessProductPaymentCheckoutPage {
	private form : FormGroup;
	orderDetail: any = [];
	hasProducts: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;

	loadingMsg: any = "Loading...";
	isRefreshing: boolean = false;
	lastRequestReturnedValues: boolean = false;
	userIsLoading: boolean = false
	isVirtualPayment: boolean = false;

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

  constructor(
  	public navCtrl: NavController, 
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public productManagerHandler: BusinessProductPaymentManagerHandler,
		public consumerHandlerProvider: ConsumerHandlerProvider,
		public checkoutHandler: ProductPaymentCheckoutHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public toastCtrl: ToastController,
		public actionSheetCtrl: ActionSheetController,
		public globals: Globals) {

  	this.form = this.formBuilder.group({
		  	"Memo":  [''],
		  	"AmountTendered": [],
		  	"CustomerChange": [0]
	   	});   
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessProductPaymentCheckoutPage');

    this.prepInvoice()
  }

  ionViewWillLeave() {

  }

  prepInvoice() {
  	// var uniqueProducts = Array.from(new Set(this.checkoutHandler.order.products.map(r=> r.ProductName)));

  // 	for(let uniqueProduct of uniqueProducts){

  // 		var count = 0;
  // 		var totalPrice = 0;

  // 		for(let selectedProduct of this.checkoutHandler.order.products){

	 //  			if(selectedProduct.ProductName == uniqueProduct) {
		// 				count++
		// 				totalPrice += selectedProduct.Price
	 //  			}
		// 	}

		// 	var productObj = {
		// 		ProductName: uniqueProduct,
		// 		Count: count,
		// 		Price: totalPrice
		// 	}

		// 	this.orderDetail.push(productObj)
		// }

		for(let product of this.checkoutHandler.order.products){

	  		var count = 0;
	  		var totalPrice = 0;
	  		var modifiers = "";

	  		for(let modifier of product.Modifiers) {
	  			modifiers += modifier.ModifierName + " "
	  		}

			var productObj = {
				ProductName: product.ProductName,
				Count: count,
				Price: product.Price,
				Modifiers: product.Modifiers
			}

			this.orderDetail.push(productObj)
		}
  }

  tryDebitMoney(){
		let actionSheet = this.actionSheetCtrl.create({
			title: "$ " + this.checkoutHandler.order.total + " will be charged to the customer. Are you sure?",
			enableBackdropDismiss: false,
			buttons: [
			{
			   text: 'Yes',
			   handler: () => {
			       console.log('Archive clicked');

			       this.debitConsumer()

			       actionSheet.dismiss();

			       return false;
			   }
			},
			{
			   text: 'No',
			   handler: () => {
			     actionSheet.dismiss();

			     return false;
			   }
			}]
		});

		actionSheet.present();  
	}

	debitConsumer() {
		var loader = this.loadingCtrl.create({
			content: "Charging customer...",
			showBackdrop: true
		});

		loader.present();  

		var userId = this.checkoutHandler.order.consumer.UserId ? this.checkoutHandler.order.consumer.UserId : 0;
		var businessId = this.checkoutHandler.order.consumer.BusinessId ? this.checkoutHandler.order.consumer.BusinessId : 0;

		console.log("Debit BusinessId: " + businessId);
		console.log("Debit UserId: " + userId);

		this.productManagerHandler.debitConsumer({
		    UserId: userId,
        	BusinessId: businessId,
        	Amount: this.checkoutHandler.order.total,
		    Products: this.checkoutHandler.order.products,
		    GroupJson: JSON.stringify(this.checkoutHandler.order.groups),
		    PaymentTypeId: this.checkoutHandler.order.paymentTypeId,
		    Memo: this.form.value.Memo
		})
		.then((data: any)=>{
			loader.dismiss();

			if(data.Data){
				let alert = this.alertCtrl.create({
			      title: 'Transaction Completed',
			      message: data.Message,
			      enableBackdropDismiss: false,
			      buttons: [
			        {
			          text: 'Cancel',
			          role: 'cancel',
			          handler: () => {
			            this.navParams.get("parentPage").cancel();
						this.navCtrl.pop();			            
			          }
			        },
			        {
			          text: 'Confirm',
			          handler: () => {  
			            this.navParams.get("parentPage").cancel();
						this.navCtrl.pop();
			          }
			        }
			      ]
			    });

			    alert.present();

				// let toast = this.toastCtrl.create({
				// 	message: data.Message,
				// 	duration: 5000,
				// 	position: 'middle',
				// 	showCloseButton: true,
				// 	closeButtonText: 'Ok'
				// });

				// toast.onDidDismiss(() => {
					
				// });

				// toast.present();

			} else if (data.Message){
				let toast = this.toastCtrl.create({
					message: 'There was an error: ' + data.Message,
					duration: 5000,
					position: 'middle'
				});

				toast.present();  
			}
		})
		.catch((err)=>{
			loader.dismiss();

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'middle'
			});

		  	toast.present();  
		});
	}

	setPaymentType(paymentType) {

		this.isVirtualPayment = paymentType.IsVirtual

		this.checkoutHandler.order.paymentTypeId = paymentType.Id;
	}

	calculateChange(){
		if(this.form.value.AmountTendered < this.checkoutHandler.order.total){
			let toast = this.toastCtrl.create({
				message: 'Amount tendered does not cover the order total.',
				duration: 3000,
				position: 'middle'
			});

		  	toast.present();

		  	return
		}

		var customerChange = Math.abs(this.form.value.AmountTendered - this.checkoutHandler.order.total);

		this.form.controls['CustomerChange'].setValue(customerChange);
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-product-payment-checkout/business-product-payment-checkout.ts